<div class="page-content">
    <div class="page-header">
        <h1>
            @if(contributor && contributor.id){ 
                {{contributor.firstname}} {{contributor.lastname}} ({{contributor.mail}})
            }
            @else{
                Contributeur
            }</h1>
    </div>

    <div class="page-body">
        <div class="row g-3">
             <div class="col-sm-6 col-lg-3 g-3">
                <kpi-card
                    title="Statut"
                    [body]="{value: contributor?.employmentStatus}"
                    [isLoading]="!contributor"
                    class="h-100"></kpi-card>
            </div>
            @if(contributor?.departureDate){
                <div class="col-sm-6 col-lg-3 g-3">
                    <kpi-card
                        title="Statut"
                        [body]="{value: contributor?.departureDate?.toLocaleDateString() }"
                        [isLoading]="!contributor"
                        class="h-100"></kpi-card>
                </div>
            }
            
        
        </div>
        <br/>
        <div class="row g-3">
            <div class="col-sm-12">
                 <table-card 
                        title="Contributions"
                        [sortInfo]="{field: 'total', order: -1}"
                        [isLoading]="!contributor" 
                        [dataSource]="totalTimeData" 
                        [displayedColumns]="totalTimeColumns"
                        (onRowClick)="goToPhase($event)"
                        >
                    </table-card>
            </div>
        </div>
        <br/>
        <div class="row g-3">
            <div class="col-sm-12">
                 <table-card 
                        title="Contributions détaillées"
                        [sortInfo]="{field: 'total', order: -1}"
                        [isLoading]="!contributor" 
                        [dataSource]="monthlyTimeData" 
                        [displayedColumns]="monthlyTimeColumns"
                        (onRowClick)="goToPhase($event)"
                        >
                    </table-card>
            </div>
        </div>

              
    </div>
</div>